import { useContext } from "react";
import { ThemeContext, ThemeContextValue } from "../contexts/ThemeContext";

/**
 * Hook to access theme context
 * @throws Error if used outside of ThemeProvider
 * @returns ThemeContextValue containing theme and setTheme
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
}